import TableTooltip from './TableTooltip'

export const DEFAULT_DELAY = 500; // 0.5 sec

/**
 *
 * @param tooltipId id of tooltip element
 * @param delay delay in ms before tooltip will be showed (0.5 sec by default)
 * @returns {DelayTooltip}
 */
class DelayTooltip extends TableTooltip {
    init(tooltipId, delay)
    {
        super.init(tooltipId);

        if (delay)
        {
            this.delay = delay;
        }
        else
        {
            this.delay = DEFAULT_DELAY;
        }
        this.isDelayed = true;

        this.hide(); // hide tooltip after init

        return this;
    }

    showWithDelay()
    {
        this.tooltipDelayTimer = setTimeout(() => {
                                                this._setVisible(true) // show tooltip
                                            },
                                            this.delay
        )
    }

    updateUIAndShow(config, offset)
    {
        super.updateUIAndShow(config, offset)
        if (this.isDelayed)
        {
            this.showWithDelay() // show after delay
        }
        else
        {
            this._setVisible(true)
        }
    }

    hide()
    {
        if (this.tooltipDelayTimer && this.isDelayed)
        {
            clearTimeout(this.tooltipDelayTimer);
        }
        this._setVisible(false); // hide tooltip
        super.hide();
    }

    _setVisible(isVisible)
    {
        if (isVisible)
        {
            this._tooltipEl.css("visibility", "visible");
        }
        else
        {
            this._tooltipEl.css("visibility", "hidden");
        }
    }

    /**
     * on/off delay
     * @param isDelayed
     */
    needDelay(isDelayed)
    {
        this.isDelayed = isDelayed;
    }

    /**
     * set value of delay
     * @param newDelay
     */
    setDelay(newDelay)
    {
        this.delay = newDelay;
    }
}

export default DelayTooltip



// WEBPACK FOOTER //
// ./web/js/controls/DelayTooltip.js